module.exports = __webpack_public_path__ + "img/discount.fbc9444.png";